import * as React from "react";
import * as PropTypes from "prop-types";
import styled, { StyledComponentClass } from "styled-components";
import Logo from "../Logo";
import Toolbar from "../Toolbar";
import MobileToolbar from "../MobileToolbar";
import HeaderbarBottom from "./HeaderbarBottom";
import OverlayNav from "../OverlayNav";
import Navbar from "../Navbar";
import { logOut } from "../../../../auth/logout";

import { NavStructurePropTypes, ToolbarItemsPropTypes } from "../../vars";
import { BREAK_POINTS } from "@origin-digital/style-guide";

const ResponsiveWrapper: StyledComponentClass<any, any> = styled.div`
  display: ${({ isMobile }: any) => (isMobile ? "block" : "none")};

  ${({ isMobile }: any) => (isMobile ? "position: relative;" : "")};

  @media (min-width: ${BREAK_POINTS.Min.LG}) {
    display: ${({ isMobile }: any) => (isMobile ? "none" : "block")};
  }
`;

class Headerbar extends React.Component<any, any> {
  static propTypes = {
    ...NavStructurePropTypes,
    ...ToolbarItemsPropTypes,
    logoutUrl: PropTypes.string,
    sandbox: PropTypes.bool
  };

  static defaultProps = {
    sandbox: false,
    logoutUrl: "/"
  };

  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false
    };
  }

  openMenu = () => ({ menuOpen: true });

  closeMenu = () => ({ menuOpen: false });

  handleMenuToggleClick = () => {
    this.setState(this.openMenu);
  };

  handleCloseMenuClick = () => {
    this.setState(this.closeMenu);
  };

  handleLogoutClick = () => {
    logOut();
  };

  render() {
    const { navStructure, toolbarItems, className } = this.props;

    return (
      <div
        id="my-account-nav"
        data-id="my-account-nav"
        data-logout-url={this.props.logoutUrl}
        className={className}
        role="navigation"
      >
        <Logo absolute />

        <ResponsiveWrapper isMobile={true}>
          <MobileToolbar onMenuToggleClick={this.handleMenuToggleClick} />
          <OverlayNav
            open={this.state.menuOpen}
            onCloseMenuClick={this.handleCloseMenuClick}
            onLogoutClick={this.handleLogoutClick}
            navStructure={navStructure}
          />
        </ResponsiveWrapper>
        <ResponsiveWrapper isMobile={false}>
          <Toolbar items={toolbarItems} />
          <HeaderbarBottom>
            <Navbar navStructure={navStructure} />
          </HeaderbarBottom>
        </ResponsiveWrapper>
      </div>
    );
  }
}

export default Headerbar;
